import { useMutation } from "@tanstack/react-query"
import { useState } from "react"

import loginApi from "../../../api/login/loginApi"
import { resolveSafeReturnUrl } from "../../../logic/auth/returnUrl"
import useForm from "../../../hooks/useForm"

type LoginFormValues = {
  loginId: string
  password: string
}

const useLoginForm = (options: { onLogin?: () => void; shouldRedirect?: boolean } = {}) => {
  const { onLogin, shouldRedirect = true } = options

  const [values, setValues] = useState<LoginFormValues>({
    loginId: "",
    password: "",
  })

  const { getFieldProps } = useForm(values, setValues)

  const getInputProps = <Name extends keyof LoginFormValues>(name: Name) => {
    const baseProps = getFieldProps(name)
    return {
      name: baseProps.name,
      value: baseProps.value,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) => baseProps.onChange(e),
      onBlur: (e: React.FocusEvent<HTMLInputElement>) => baseProps.onBlur(e),
      ref: baseProps.ref,
    }
  }

  const [errorMessage, setErrorMessage] = useState("")
  const [isAccountLocked, setIsAccountLocked] = useState(false)

  const { mutate, isLoading } = useMutation(() => loginApi.login(values.loginId, values.password), {
    onMutate() {
      setErrorMessage("")
      setIsAccountLocked(false)
    },
    onSuccess(result) {
      if (result.isError) {
        setErrorMessage(result.data.message)
        return
      }
      if (result.data.resultCode === "ACCOUNT_LOCKED") {
        setIsAccountLocked(true)
        setErrorMessage(result.data.errorMessage)
        return
      }
      if (result.data.resultCode === "NG") {
        setErrorMessage(result.data.errorMessage)
        return
      }
      onLogin?.()
      if (shouldRedirect) {
        // TODO router.pushを使って遷移できる場合そちらを使うようにする。
        window.location.assign(resolveSafeReturnUrl() ?? "/kiban/com/csComTop.do")
      }
    },
  })

  return {
    loginIdProps: getInputProps("loginId"),
    passwordProps: getInputProps("password"),
    errorMessage,
    isAccountLocked,
    login: () => mutate(),
    isLoading,
  }
}

export default useLoginForm
